import { useTranslation } from "react-i18next";
import { useStatusesStore } from "../../../../../../store/admin/statusesStore";
import type { ThemeClasses } from "../types";
import Select from "react-select";
import { getCustomSelectStyles, FilterPopover } from "../../../../shared";
import { getStatusOptionsForEntity } from "../../../../../../utils/getStatusEntity";

interface RouteFiltersProps {
  status_id: string;
  searchQuery: string;
  isDarkMode: boolean;
  themeClasses: ThemeClasses;
  onStatusChange: (value: string | null) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function RouteFilters({
  status_id,
  searchQuery,
  isDarkMode,
  themeClasses,
  onStatusChange,
  onSearchChange,
}: RouteFiltersProps) {
  const { t } = useTranslation("adminSections");

  const statuses = useStatusesStore((state) => state.statuses);
  const statusOptionsSelect = getStatusOptionsForEntity(statuses, "routes", t);

  return (
    <div className="flex items-center gap-2 flex-1 min-w-0">
      {/* Búsqueda */}
      <div className="relative flex-1 min-w-0 sm:flex-none sm:w-72">
        <i
          className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 ${themeClasses.textSecondary}`}
        ></i>
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchChange}
          placeholder={t("routes.searchPlaceholder")}
          className={`w-full h-9 pl-10 pr-4 py-2 ${isDarkMode ? "bg-dark-card" : "bg-gray-50"
            } border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} text-sm focus:outline-none focus:ring-2 focus:ring-primary-500`}
        />
      </div>
      <FilterPopover
        isDarkMode={isDarkMode}
        activeCount={status_id ? 1 : 0}
        onClear={() => onStatusChange(null)}
      >
        <Select
          options={statusOptionsSelect}
          styles={getCustomSelectStyles<{ value: string; label: string }, false>(isDarkMode)}
          placeholder={t("routes.filters.selectStatus")}
          value={statusOptionsSelect.find((opt) => opt.value === status_id) || null}
          onChange={(option) => onStatusChange(option?.value || null)}
          isSearchable
          isClearable
          noOptionsMessage={() => t("routes.filters.noStatusesAvailable")}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </FilterPopover>
    </div>
  );
}
